import React, { useCallback, useMemo } from 'react';
import { TrendingNftsContainer } from 'src/features/common/collectible/containers/trending-nfts-container';
import {
    ISectionConfiguration,
    TWizardSection,
} from 'src/features/common/universe-wizard/context/wizard-context.types';
import { CreatorsMainContainer } from 'src/features/common/universe/containers/creators-main-container';
import { TUniverseComponent } from 'src/features/common/universe/universe.types';
import { UniverseTopBannerContainer } from 'src/features/white-labels/nftsuperlab/banner/containers/universe-top-banner-container';
import { HighlightedQuestions } from 'src/features/white-labels/nftsuperlab/faq/containers/highlighted-questions';
import { AboutUniverse } from 'src/features/white-labels/nftsuperlab/universe/components/about-universe';
import { LatestCollections } from 'src/features/white-labels/nftsuperlab/universe/components/latest-collections';

interface Args<T> {
    // @ts-ignore
    configurations: ISectionConfiguration<T>[];
}

const COMPONENTS_MAPPING: Record<TUniverseComponent, React.ElementType> = {
    latestNfts: TrendingNftsContainer,
    about: AboutUniverse,
    banner: UniverseTopBannerContainer,
    latestCollections: LatestCollections,
    creators: CreatorsMainContainer,
    faq: HighlightedQuestions,
};

const COMPONENTS_SORTING: Record<TUniverseComponent, number> = {
    banner: 1,
    about: 2,
    latestCollections: 3,
    creators: 4,
    latestNfts: 5,
    faq: 6,
};

export const useCollectTemplateComponents = ({ configurations }: Args<TWizardSection>): React.ReactNode[] => {
    const renderComponent = useCallback(
        (Component: React.ElementType, props: any, section: string): React.ReactNode => (
            // @ts-ignore
            <Component key={section} {...props} {...props.value} />
        ),
        []
    );

    return useMemo(
        () =>
            configurations
                ?.sort(
                    (a, b) =>
                        COMPONENTS_SORTING[a.section as TUniverseComponent] -
                        COMPONENTS_SORTING[b.section as TUniverseComponent]
                )
                .map((config) => {
                    const { section, ...restProps } = config;

                    const Component: React.ElementType = COMPONENTS_MAPPING[section as TUniverseComponent];

                    return Component ? renderComponent(Component, restProps, section) : null;
                }),
        [renderComponent, configurations]
    );
};
